/**
 * A phone either way up: narrower than `sm`, or shorter than a dialog's fixed header and footer leave room
 * in. The `compact:` Tailwind variant in styles/tailwind-breakpoints.css is the same query.
 */
export const COMPACT_SCREEN_QUERY = "(width < 640px), (height < 600px)";

/**
 * Responsive breakpoint widths
 */
export enum BREAKPOINT {
    XS = "480px",
    SM = "640px",
    MD = "768px",
    LG = "1024px",
    XL = "1280px",
    "2XL" = "1536px",

    /**
     * Specific ad-hoc breakpoints
     * ==============================
     */

    // Screen width at which we should pan the map to move the selected marker into view (to avoid being hidden by the card)
    DEVICE_CARD_PAN = "900px",

    // Screen width at which the device card should take up the entire width (no x-margin)
    DEVICE_CARD_FULL_WIDTH = "900px",

    // Screen width at which the weather card should take up the entire width (no x-margin)
    WEATHER_CARD_FULL_WIDTH = "1200px",

    // Screen width at which the zone card should take up the entire width (no x-margin)
    ZONE_CARD_FULL_WIDTH = "900px",

    // Screen width at which the aoi card should take up the entire width (no x-margin)
    AOI_CARD_FULL_WIDTH = "900px",
}
